class DisneyRewardsApplyNow {

    constructor(element) {
        this.cacheData(element);
    }

    /**
     * Stores references to reusable data related to this class.
     * @param {HTMLElement} element The HTML element representing the block instance.
     */
    cacheData(element) {
        this.applyButton = element;
    }
}

(() => {
    document.addEventListener('DOMContentLoaded', () => {
        const blocks = document.querySelectorAll('[tracking-code-enabled="true"]');

        if (blocks.length) {
            blocks.forEach((block) => {
                window.disneyRewards.blocks.push(new DisneyRewardsApplyNow(block));
            });
        }
    });
})();
